import React from 'react'
import { Subscribe } from 'unstated'
import { withRouter } from 'react-router-dom'
import Button from '../../../../../Components/Buttons/Button'
import CourseStore from '../../../Store/CourseStore'

const Teacher = ({ history, restricted }) => (
  <Subscribe to={[CourseStore]}>
    {({ state }) => {
      const { name, description, teaches, image, coverImage } = state.teacher
      return (
        <div
          className='teacher'
          style={restricted ? { pointerEvents: 'none' } : {}}
        >
          <div
            className='image'
            style={{
              background: `url(${
                image || coverImage?.document?.location
              }) center center /contain no-repeat`,
            }}
          >
            <div className='fadeOverlay' />
          </div>
          <div className='info'>
            <p className='sectionTitle'>About the Artist</p>
            <h1 className='name'>{name}</h1>
            <h1 className='teaches'>{teaches}</h1>
            <p className='description'>{description}</p>
            <Button
              onClick={() => history.push(`/${state.livDemyID}`)}
              name={'View More Classes'}
              type={'primary big'}
            />
          </div>
        </div>
      )
    }}
  </Subscribe>
)

export default withRouter(Teacher)
